<template>
  <b-container class="lateral">
    <b-row class="mt-2">
      <b-col sm="12" md="4">
        <b-form-group
          :label="$t('checklist.pendencies.dueDate')"
          label-for="dueDate"
          title="Qual a frequência que a pendência vai vencer após a geração"
          v-b-tooltip.hover
        >
          <b-form-select
            id="PendencyExpirationIntervalType"
            :options="optionsIntervalType"
            v-model="dueDate.dueDateIntervalType"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          v-if="dueDate.dueDateIntervalType != 0"
          :label="getPendencyDueDateIntervalRangeLabel(dueDate.dueDateIntervalType)"
          label-for="PendencyExpirationIntervalRange"
          class="mb-4"
          title="Em quanto tempo a pendência vai vencer após a geração"
          v-b-tooltip.hover
        >
          <base-input-integer
            id="dueDateIntervalRange"
            placeholder="Insira em quanto tempo irá vencer"
            :value.sync="dueDate.dueDateIntervalRange"
            :readonly="false"
          >
          </base-input-integer>
        </b-form-group>
      </b-col>
    </b-row>
    
    <b-row v-if="dueDate.dueDateIntervalType != 0">
      <form-pendency-notify :items.sync="dueDate.formPendencyNotifies">
      </form-pendency-notify>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "PendencyDueDateCrud",
  components: {
    BaseInputInteger: () =>
      import("@/components_rms/base/BaseInputInteger.vue"),
    FormPendencyNotify: () =>
      import("@/components_rms/checklist/form/FormPendencyNotify.vue"),
  },
  props: {
    dueDate: Object
  },
  data() {
    return {
      optionsIntervalType: [
        { value: 0, text: "Não vence" },
        { value: 1, text: "Hora" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
        { value: 5, text: "Ano" },
      ],
    };
  },

  methods: {
    getPendencyDueDateIntervalRangeLabel(item) {
      let text = this.$t("checklist.pendencies.timeToDueDate");
      if (item) {
        switch (item) {
          case 1:
            return `${text} (Horas)`;
          case 2:
            return `${text} (Dias)`;
          case 3:
            return `${text} (Semanas)`;
          case 4:
            return `${text} (Meses)`;
          case 5:
            return `${text} (Anos)`;
          default:
            return text;
        }
      }
      return text;
    },
  },
};
</script>
<style scoped>
.lateral {
  margin-left: -10px;
}
</style>
